'use client';

import { Card, CardContent } from '@/components/ui/card';
import type { VerificationTemplateProps } from './types';

function statusLabel(status: string) {
    switch (status) {
        case 'valid':
            return { icon: '✅', label: 'Valid' };
        case 'revoked':
            return { icon: '🚫', label: 'Revoked' };
        case 'expired':
            return { icon: '⏰', label: 'Expired' };
        default:
            return { icon: '❓', label: 'Unknown' };
    }
}

export default function TemplateMinimal({ certificate, tenant, verificationCode }: VerificationTemplateProps) {
    const issuerDisplayName = tenant?.issuerName || tenant?.name || 'Sigalmark';
    const { icon, label } = statusLabel(certificate.status);

    return (
        <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
            <Card className="w-full max-w-xl">
                <CardContent className="p-6 space-y-5">
                    <div className="flex items-start justify-between gap-4">
                        <div>
                            <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Verification</p>
                            <h1 className="text-2xl font-semibold">{certificate.name}</h1>
                            <p className="text-sm text-muted-foreground">Issued by {issuerDisplayName}</p>
                        </div>
                        <div className="text-right">
                            <div className="text-3xl">{icon}</div>
                            <div className="text-sm font-semibold">{label}</div>
                        </div>
                    </div>

                    <div className="rounded-xl border border-border bg-muted/20 p-4">
                        <p className="text-sm text-muted-foreground">Verification number</p>
                        <p className="mt-1 text-sm break-all font-mono">{verificationCode}</p>
                    </div>

                    {certificate.explorerUrl ? (
                        <a
                            href={certificate.explorerUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm underline text-primary"
                        >
                            View on blockchain explorer
                        </a>
                    ) : null}

                    <p className="text-xs text-muted-foreground">
                        Powered by{' '}
                        <a
                            href="https://sigalmark.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                        >
                            sigalmark™
                        </a>
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}
